import { FetchAPI } from "@renedelangel/helpers";

import { urlServidor } from '../../helpers';

const ejecutar = async ({ query, variables, campo, token }) => {
    try {
        let resultado = await FetchAPI.graphql({ token, variables, url: urlServidor, query });
        return resultado[campo];
    } catch ({ message }) { throw new Error(message); }
};

export const upsertEncuestaCatSeccion = async (variables, token) => await ejecutar({
    token, variables, campo: "upsertEncuestaCatSeccion",
    query: `mutation upsert($input: InputUpsertEncuestaCatSecciones){ upsertEncuestaCatSeccion(input: $input){ seccionCatID clave } }`
});

export const deleteEncuestaCatSeccion = async (input, token) => await ejecutar({
    token, variables: { input }, campo: "deleteEncuestaCatSeccion",
    query: `mutation eliminar($input: InputDeleteEncuestaCatSecciones){ deleteEncuestaCatSeccion(input: $input) }`
});

export const upsertEncuestaCatPregunta = async (variables, token) => await ejecutar({
    token, variables, campo: "upsertEncuestaCatPregunta",
    query: `mutation upsert($input: InputUpsertEncuestaCatPreguntas){ upsertEncuestaCatPregunta(input: $input){ preguntaCatID tipo } }`
});

export const deleteEncuestaCatPregunta = async (input, token) => await ejecutar({
    token, variables: { input }, campo: "deleteEncuestaCatPregunta",
    query: `mutation eliminar($input: InputDeleteEncuestaCatPreguntas){ deleteEncuestaCatPregunta(input: $input) }`
});

export const upsertEncuestaCatOpcion = async (variables, token) => await ejecutar({
    token, variables, campo: "upsertEncuestaCatOpcion",
    query: `mutation upsert($input: InputUpsertEncuestaCatOpciones){ upsertEncuestaCatOpcion(input: $input){ opcionCatID } }`
});

export const deleteEncuestaCatOpcion = async (input, token) => await ejecutar({
    token, variables: { input }, campo: "deleteEncuestaCatOpcion",
    query: `mutation eliminar($input: InputDeleteEncuestaCatOpciones){ deleteEncuestaCatOpcion(input: $input) }`
});
